import React, { useEffect, useState, useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Container, Card, Nav, Button, Spinner } from 'react-bootstrap';
import ErrorMessage from '../../../components/Error/ErrorMessage';
import Programs from './Programs/Programs';
import { IProgramsListContext, ProgramsListContext } from '../../../application/context/Programs/ProgramsList/ProgramsListContext';
import IProgramFailure from '../../../domain/core/failures/program/programFailure';
import qs from "qs";


export default function Index() {
    const { state, actions, dispatch } = useContext<IProgramsListContext>(ProgramsListContext);
    const { getPrograms, getProgramsByQuery } = actions;
    const { loading, error, limit } = state.getProgramsState;

    const [hasError, setHasError] = useState<IProgramFailure | null>(null);

    const location = useLocation();
    const nextPage = qs.parse(location.search, { ignoreQueryPrefix: true }).next_page;
    const prevPage = qs.parse(location.search, { ignoreQueryPrefix: true }).prev_page;
    const searchQuery = qs.parse(location.search, { ignoreQueryPrefix: true }).search_query;

    const fetchPrograms = () => {
        if (!searchQuery) {
            getPrograms({
                start: nextPage ?? prevPage ?? null,
                isNext: nextPage,
                isPrevious: prevPage,
                limit: limit + 1,
            })(dispatch);
            return;
        }
        
        getProgramsByQuery({
            start: nextPage ?? prevPage ?? null,
            isNext: nextPage,
            isPrevious: prevPage,
            limit: limit + 1,
            searchQuery: searchQuery ?? null,
        })(dispatch);
    }

    useEffect(() => {
        let isMounted = true;

        if (isMounted) fetchPrograms();

        return () => {
            isMounted = false;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [nextPage, prevPage, searchQuery])

    useEffect(() => {
        if (error) setHasError(error);
    }, [error])

    return (
        <Container fluid>
            <div className="w-100">
                <Card className="card-rounded bg-primary pt-0 pb-0 pl-4 pr-4">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <Nav className="nav--peer-content">
                                <NavLink exact to="/admin/dashboard/settings" activeClassName="active" className="nav-item link-box" title="Configuración">
                                    <Button variant="" className="btn-block btn-pill nav-link">Configuración</Button>
                                </NavLink>
                                <NavLink exact to="/admin/dashboard/settings/programs/page/1" className="nav-item link-box" title="Programas">
                                    <Button variant="" className="btn-block btn-pill nav-link">Programas</Button>
                                </NavLink>
                            </Nav>
                        </div>
                        <div>
                            <svg className="icon icon-white" height="28" viewBox="0 0 24 24" width="28"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"/></svg>
                        </div>
                    </div>
                </Card>
            </div>
            <div className="mt-5">
                {loading ? (
                    <div className="d-flex justify-content-center w-100 mt-5">
                        <Spinner className="spinner-border-primary" animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                ) : hasError ? (
                    <ErrorMessage OnClick={() => fetchPrograms()} fullPage={false} />
                ) : (
                    <Programs />
                )}
            </div>
        </Container>
    )
}
